import { normalizeZones } from './normalizeZones';

export const Util = {
  normalizeZones,
};
